/*
 * @Descripttion: 缓存  目前只有用头像
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-01-06 14:46:42
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-01-27 18:33:31
 */
import actionTypes from '../actionTypes'
import { fromJS } from 'immutable'
const defaultState = fromJS({ // 将对象转成immutable对象
  usercacheList: fromJS({}),
})

export default (state = defaultState, action) => {
  let newstate
  switch (action.type) {

    case actionTypes.AddUserCache:  //每次新消息来都会调用
      if (state.get('usercacheList').has(action.data.userId)) {
        // debugger
        // let newstate = state.merge({
        //   messageList: state.get('usercacheList').update(action.data.userId, value => value.push(fromJS(action.data)))
        // })       
        // console.log( state.get('usercacheList').update(action.data.userId, value => value.push(fromJS(action.data))).toJS())
        return state
      } else {
        let usercacheList = state.get('usercacheList').toObject()
        usercacheList[action.data.userId] = action.data
        newstate = state.merge({        
          usercacheList: fromJS(usercacheList)
        })
        // console.log( usercacheList)
        return newstate
      }
      break;
  }

  return state
}
